// components/ReviewTemplateList/ReviewListTabContent/index.tsx
import { useMemo, useState } from 'react';
import { Col, Row } from 'reactstrap';
import { Btn } from '../../../../AbstractElements';
import CommonReviewList from '../Common/CommonReviewList';
import { useFetchReviewTemplates } from '../../../../hooks/bookReviewTemplate/useFetchReviewTemplates';

type Props = {
  activeTab: number;
  userId: string;
  role: string;
};

export default function ReviewListTabContent({ activeTab, userId, role }: Props) {
  // Map activeTab to status param expected by backend:
  // 1 -> all, 2 -> pre, 3 -> active, 4 -> post
  const status = useMemo(() => {
    if (activeTab === 1) return 'pre';
    if (activeTab === 2) return 'active';
    if (activeTab === 3) return 'post';
    return 'all';
  }, [activeTab]);

  const [page, setPage] = useState<number>(1);
  const limit = 12;

  const { templates, total, loading, refetch } = useFetchReviewTemplates(userId, role, status as any, page, limit);

  const totalPages = Math.max(1, Math.ceil((total || 0) / limit));

  return (
    <div>
      <Row className="g-3">
        {loading && (
          <Col>
            <div style={{ padding: 24 }}>Loading templates...</div>
          </Col>
        )}

        {!loading && templates.length === 0 && (
          <Col>
            <div style={{ padding: 24 }}>No data found.</div>
          </Col>
        )}

        {templates.map((item: any) => (
          <CommonReviewList key={item._id || item.id} item={item} refetchTemplates={() => refetch(page, limit, status)} />
        ))}
      </Row>

      {/* pagination */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginTop: 18 }}>
        <Btn
          type="button"
          color="secondary"
          disabled={page <= 1}
          onClick={() => {
            setPage((p) => Math.max(1, p - 1));
          }}
        >
          Prev
        </Btn>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          Page {page} of {totalPages}
        </div>
        <Btn
          type="button"
          color="secondary"
          disabled={page >= totalPages}
          onClick={() => {
            setPage((p) => Math.min(totalPages, p + 1));
          }}
        >
          Next
        </Btn>
      </div>
    </div>
  );
}
